<template>
    <div id="lut-previews-container" class="hide">
        <vue-resizable id="lut-previews-container__resizable"
                       @resize:move="onResize"
                       :min-width="300"
                       :actice="['r']"
        >
            <div class="lut-preview-tab-header">
                <span id="lut-preview-tab-title"></span>
                <RegenerateAIPredictionsButton />
            </div>
            <div id="previews-list-container" name="previews-list-container" class="scrollable-con"></div>
            <tippy
                theme="--start"
                to="previews-list-container"
                placement="left-start"
                boundary="window"
                trigger="manual"
            >
                <span class="title">Select AI model</span>
                <span class="description">
						Please select an AI generated grade. After applying a grade, you can adjust its parameters on the left in the Tools column.
                </span>
            </tippy>
        </vue-resizable>
    </div>
</template>

<script>
import VueResizable from 'vue-resizable'
import RegenerateAIPredictionsButton from "@/components/app/buttons/RegenerateAIPredictionsButton.vue";

export default {
    name: 'LUTPreviewTemplate',
    components: {RegenerateAIPredictionsButton, VueResizable},
    methods: {
        onResize() {
            window.UI.paneResized();
        }
    }
}
</script>

<style lang="scss" scoped>
#lut-previews-container__resizable {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 54px 1fr;
    height: 100% !important;
    animation: none !important;
    transition: initial !important;

    * {
        animation: none !important;
        transition: initial !important;
    }
}

#lut-previews-container {
    height: 100%;
    position: absolute;
    left: 100%;
    top: 0;
    z-index: 10;
    background-color: var(--bg-sidebar-left);
    border-radius: 0 var(--box-rounding) var(--box-rounding) 0;
    border-left: 1px solid var(--color-group-separator);

    ::v-deep #luts-preview-canvas {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100vh;
        pointer-events: none;
    }
}

.lut-preview-tab-header {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 10;
    background-color: #121212;
    border-radius: 0 var(--box-rounding) 0 0;
    //
    //.v-btn {
    //    position: absolute;
    //    left: 8px;
    //    top: 50%;
    //    transform: translateY(-50%);
    //    min-width: auto;
    //    height: auto;
    //    box-shadow: none;
    //    background-color: transparent;
    //    color: var(--font-default-color);
    //    padding: 3px;
    //}
}

#lut-preview-tab-title {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    text-transform: uppercase;
    font-size: 0.9rem;
    color: var(--font-default-color);
}

#previews-list-container {
    overflow-y: scroll;
    overflow-x: hidden;
    padding: 0 15px;
    //height: calc(100vh - 155px); // Safari fix
    z-index: 1;
}
</style>